export const IMAGE_POSTFIX = 400
export const IMAGE_POSTFIX_MOBILECARD = "mobilecard"
export const IMAGE_POSTFIX_WEBCARD = "webcard"
export const IMAGE_POSTFIX_WEBFULL = "webfull"
export const BLUR_POSTFIX = "blr"
